import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE, NativeDateAdapter } from '@angular/material/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { IonContent } from '@ionic/angular';
import { ToastrService } from 'ngx-toastr';
import { Config } from 'src/app/app-constant';
import { EncryptionService } from 'src/app/service/encryption/encryption.service';
import { HttpService } from 'src/app/service/http/http.service';
import { ConfirmationDialogComponentComponent } from '../../payroll/__generic-components/confirmation-dialog-component/confirmation-dialog-component.component';
import { ConfirmationPopupComponent } from 'src/app/shared/popups/confirmation-popup/confirmation-popup.component';
import { DatePipe } from '@angular/common';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import html2pdf from 'html2pdf.js';
export class AppDateAdapter extends NativeDateAdapter {
  override format(date: Date, displayFormat: Object): string {
    if (!date) return '';
    const day = this._to2digit(date.getDate());
    const month = this._to2digit(date.getMonth() + 1);
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  }

  private _to2digit(n: number) {
    return ('00' + n).slice(-2);
  }
}

export const APP_DATE_FORMATS = {
  parse: {
    dateInput: 'dd/MM/yyyy',
  },
  display: {
    dateInput: 'dd/MM/yyyy',
    monthYearLabel: 'MMM yyyy',
    dateA11yLabel: 'dd/MM/yyyy',
    monthYearA11yLabel: 'MMMM yyyy',
  },
};

@Component({
  selector: 'app-no-due-form',
  templateUrl: './no-due-form.component.html',
  styleUrls: ['./no-due-form.component.scss'],
  providers: [
    { provide: DateAdapter, useClass: AppDateAdapter },
    { provide: MAT_DATE_FORMATS, useValue: APP_DATE_FORMATS },
    { provide: MAT_DATE_LOCALE, useValue: 'en-GB' }
  ]
})
export class NoDueFormComponent implements OnInit {
  data: any
  employee: any
  finalData: any
  year: any;
  companyId: any;
  loggedInCompanyFiscalyear: any
  loggedInUserName: any
  loggedInUserRole: any
  empCode: any;
  buttonColorName: any;
  report: any;
  mailSendCheck:boolean=false;
  constructor(private dialog: MatDialog, private datePipe: DatePipe, public dialogRef: MatDialogRef<NoDueFormComponent>, private encryptionService: EncryptionService, @Inject(MAT_DIALOG_DATA) public Employeedata: any, private config: Config, private httpService: HttpService, private toastr: ToastrService,) {
    console.log("Employeedata", Employeedata?.employeeData);
    this.data = Employeedata?.employeeData;
    this.year = Employeedata?.year;
    this.companyId = Employeedata?.companyId;
    this.report = Employeedata?.report;
    this.mailSendCheck=Employeedata?.employeeData?.mailSend
    //  let lastWorkingDates = this.datePipe?.transform(this.data?.lastWorkingDay, 'dd-MM-yyyy');
    let lastWorkingDay = this.data?.lastWorkingDay;

    if (lastWorkingDay) {
      if (typeof lastWorkingDay === 'string' && lastWorkingDay.includes('-') && lastWorkingDay.length === 10) {
        // Already dd-MM-yyyy
        lastWorkingDay = lastWorkingDay;
      } else {
        // ISO or Date object
        lastWorkingDay = this.datePipe?.transform(lastWorkingDay, 'dd-MM-yyyy');
      }
    } else {
      lastWorkingDay = this.data?.lastWorkingDate || this.data?.lwd;
    }

    this.employee = {
      name: this.data?.empName,
      lastWorkingDate: lastWorkingDay,
      resignationDate: this.data?.resignDate,
      code: this.data?.empCode,
      managerCode: this.data?.managerCode,
      terminationDate: this.data?.dateOfTermination
    };
    this.transformEmployeeAssetData(this.data);
  }
  ngOnInit() {
    this.loggedInCompanyFiscalyear = sessionStorage.getItem('loggedInCompanyFiscalyear');
    this.loggedInUserName = sessionStorage.getItem('loggedInUserName');
    this.buttonColorName = sessionStorage.getItem('buttonColorName');
    this.empCode = sessionStorage.getItem('empCode');
    this.loggedInUserRole = sessionStorage.getItem('loggedInUserRole');
    if (this.loggedInUserRole) {
      this.loggedInUserRole = this.encryptionService.decryptData(this.loggedInUserRole);
    }
    if (this.loggedInCompanyFiscalyear) {
      this.loggedInCompanyFiscalyear = this.encryptionService.decryptData(this.loggedInCompanyFiscalyear);
    }

    // ✅ Wait until dialog fully opens
    this.dialogRef.afterOpened().subscribe(() => {
      setTimeout(() => {
        const container = document.querySelector('.no-dues-form');
        if (container) {
          container.scrollTop = 0;
          console.log('Scroll reset to top after open');
        }
      }, 50); // small delay ensures layout is ready
    });
    this.assetAllocationData();
    this.managerData();
    this.hrVerificationMethod();
  }
  closeForm() {
    this.dialogRef.close(); // ✅ closes Material Dialog
  }

  ngAfterViewInit() {
    const container = document.querySelector('.no-dues-form');
    if (container) container.scrollTop = 0;
  }
  transformEmployeeAssetData(employee: any) {
    // ✅ Transform data into desired JSON structure
    this.finalData = {
      empName: employee?.empName,
      empCode: employee?.empCode,
      resignDate: employee?.resignDate,
      lwd: employee?.lwd,
      status: "Pending",

      asset: employee?.asset?.map((a: any) => a) || [],
      origenalStatus: employee?.origenalStatus?.map((a: any) => ({
        date: '',
        status: a || "Asset Given",
        returned: false // ✅ true if returned, else false
      })) || [],
      allocatingAuthorityName: employee?.allocatingAuthorityName?.map((a: any) => a) || [],
      dateOfAllocation: employee?.dateOfAllocation?.map((a: any) => a) || []
    };

    console.log("✅ Final JSON:", this.finalData);
    return this.finalData;
  }

  originalAssets: any[] = [];
  allUsers: any = []
  assetAllocationData() {
    this.httpService.callGetService(`${this.config.assetAllocation}/${this.companyId}/${this.loggedInCompanyFiscalyear}/${this.year}`)
      .subscribe((elm: any) => {
        console.log(elm);

        this.originalAssets = elm.data.filter((e: any) => e.userId == this.data?.userId);
        console.log("8888.............................", this.originalAssets);

        // this.groupAssetsByName();
        this.groupEmployees();
      })

  }

  groupEmployees() {
    // Initialize an empty array to hold all users
    this.allUsers = [];
    console.log("999999...............", this.originalAssets);

    // Loop through the original assets and collect all user details
    for (const asset of this.originalAssets) {
      this.allUsers.push({
        id: asset?.id,
        employeeName: asset?.employeeName,
        employeeComment: asset?.employeeComment,
        employeeAssetStatus: asset?.employeeAssetStatus,
        allocatingAuthorityName: asset?.authorityName,
        authorityDepartment: asset?.authorityDepartment,
        employeeEmail: asset?.employeeEmail,
        authorityEmail: asset?.authorityEmail,
        assetName: asset?.assetName,
        band: asset?.band,
        userId: asset?.userId,
        assetId: asset?.assetId,
        dateOfAllocation: asset?.dateOfAllocation,
        currentAssetDescription: asset?.currentAssetDescription,
        authorityCommentDate: asset?.authorityCommentDate,
        employeeCommentDate: asset?.employeeCommentDate,
        authorityDepartmentComment: asset?.authorityDepartmentComment,
        returned: asset?.authorityDepartmentComment === 'RECEIVED_AFTER_EXIT' ? true : false,
        returnDate: asset?.assetReturnDate,
        authorityFinalComment: asset?.authorityFinalComment,
        checkComment: asset?.authorityFinalComment
      });


    }





  }


  selectedRole = 'Viewer';




  isAllCleared(): boolean {
    return this.allUsers.every((a: { returned: any; }) => a.returned);
  }
  managerTasks: any
  managerData() {
    const manageData = [
      {
        companyId: this.companyId,
        year: this.year,
        activity: 'Task Handover',
        reportingManager: this.data?.managerFullName ||this.data?.managerName,
        status: null,
        comment: null,
        userId: this.data?.userId,
        managerCode: this.empCode,
      },
      {
        companyId: this.companyId,
        year: this.year,
        activity: 'Roles & Responsibilities Handover',
        reportingManager: this.data?.managerFullName ||this.data?.managerName,
        status: null,
        comment: null,
        userId: this.data?.userId,
        managerCode: this.empCode,
      },
    ];

    // ✅ Move the logic *inside* subscribe so it waits for API response
    this.httpService
      .callGetService(`${this.config.getVarification}?companyId=${this.companyId}&year=${this.year}`)
      .subscribe({
        next: (res: any) => {
          const apiData = res?.data || [];

          // Merge API data with default manager tasks
          this.managerTasks = manageData.map((task: any) => {
            const match = apiData.find(
              (e: any) => e?.userId === task?.userId && e?.activity === task?.activity
            );

            return {
              ...task,
              status: match?.status ?? false,
              comment: match?.comment ?? null,
              managerCode: match?.managerCode ?? task.managerCode,
              verificationStatus: match?.verificationStatus ?? null,
              id: match?.id ?? null, // keep id if exists
            };
          });

          console.log('✅ Final managerTasks:', this.managerTasks);
        },
        error: (err) => {
          console.error('Error fetching verification data:', err);
          this.managerTasks = manageData; // fallback to default
        },
      });
  }

  isAllCompletedManager() {
    return this.managerTasks?.every((a: { status: any; }) => a?.status);
  }

  confirmToggleChange(item: any) {
    console.log(item);

    const newValue = item.assetName;
    console.log(newValue);

    const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
      disableClose: true,
      height: '25%',
      // width: '30%',
      width: window.innerWidth <= 576 ? '100%' : window.innerWidth <= 800 ? '50%' : '30%',

      data: {
        msg: `Are you sure asset Returned ?`,
        btn2: 'Yes',
        btn1: 'No',
        btn2BgColor: this.buttonColorName,
        showSuccessIcon: false,
        showSuccessMessage: false,
        showCloseIcon: false,
      },
    });

    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) {
        // ✅ Only save if user confirmed
        this.onToggleChange(item);

      } else {
        // ❌ Revert selection if cancelled
        this.assetAllocationData()
      }
    });
  }
  managerComment(item:any){
    if(!item.authorityFinalComment){
      return
    }
     this.onToggleChange(item);
  }
  onToggleChange(item: any) {
    console.log(item);
    const payload = {
      "id": item.id,
      "employeeName": item?.employeeName,
      "employeeComment": item?.employeeComment,
      "employeeCommentDate": item?.employeeCommentDate,
      "employeeAssetStatus": item?.employeeAssetStatus,
      "allocatingAuthorityName": item?.allocatingAuthorityName,
      "allocatingAuthorityDept": item?.authorityDepartment,
      "employeeEmail": item?.employeeEmail,
      "authorityEmail": item?.authorityEmail,
      "assetName": item?.assetName,
      "band": item?.band,
      "userId": item?.userId,
      "assetId": item?.assetId,
      "dateOfAllocation": item?.dateOfAllocation,
      "currentAssetDescription": item?.currentAssetDescription,
      "authorityCommentDate": item?.authorityCommentDate,
      "authorityDepartmentComment": item?.returned ? 'RECEIVED_AFTER_EXIT' : item?.authorityDepartmentComment,
      "assetReturnDate": item?.returnDate,
      "authorityFinalComment": item?.authorityFinalComment
    }


    // console.log('🛰️ Sending API payload:', payload);

    // ✅ Example API call
    this.httpService.callPutService(`${this.config.updateByAuthority}`, payload).subscribe({
      next: (res: any) => {
        console.log('✅ API Success:', res);
        this.toastr.success(res.message);
      },
      error: (err) => {
        console.error('❌ API Error:', err);

        this.toastr.success('Failed to update asset status.');
      }
    });


  }
  onCommentBlur(m: any) {
     if(!m?.comment){
      return
    }
    if (m._oldComment !== m.comment) {
      this.onToggleChangeManager(m);
    }
  }

  verifymanager(item: any) {
    console.log(item);
    let message;
    if (item.activity == 'Task Handover') {
      message = 'Are you sure want to handover completed ?'
    } else {
      message = `Are you sure want to handover Roles & Responsibilities?`
    }
    const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
      disableClose: true,
      height: '25%',
      // width: '30%',
      width: window.innerWidth <= 576 ? '100%' : window.innerWidth <= 800 ? '50%' : '30%',

      data: {
        msg: message,
        btn2: 'Yes',
        btn1: 'No',
        btn2BgColor: this.buttonColorName,
        showSuccessIcon: false,
        showSuccessMessage: false,
        showCloseIcon: false,
      },
    });

    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) {
        // ✅ Only save if user confirmed
        this.onToggleChangeManager(item);

      } else {
        // ❌ Revert selection if cancelled
        this.managerData()
      }
    });
  }

  onToggleChangeManager(item: any) {
    console.log(item);
   
    let payload = {
      "id": item?.id,
      "companyId": this.companyId,
      "year": this.year,
      "reportingManager": item?.reportingManager,
      "activity": item?.activity,
      "comment": item?.comment,
      "status": item?.status,
      "userId": item?.userId || this.data?.userId,
      "managerCode": this.empCode,

    }

    // ✅ Example API call
    this.httpService.callPostService(`${this.config.saveVarification}`, payload).subscribe({
      next: (res: any) => {
        console.log('✅ API Success:', res);
        this.toastr.success(res.message);
        this.managerData()
      },
      error: (err) => {
        console.error('❌ API Error:', err);

        this.toastr.success('Failed to update  status.');
        this.managerData()
      }
    });


  }
  hrVerification: any;
  hrVerificationMethod() {
    this.httpService
      .callGetService(`${this.config.getHRVarification}?companyId=${this.companyId}&year=${this.year}`)
      .subscribe({
        next: (res: any) => {
          const userData = res?.data?.find((e: any) => e.userId === this.data?.userId);

          if (!userData) {
            // ⛔ No data found for this user — use default
            this.hrVerification = {
              status: 'Pending',
              comment: '',
              readyForLetter: '',
              userId: this.data?.userId,
              companyId: this.companyId,
              year: this.year
            };
            console.warn('⚠️ No HR verification data found for user:', this.data?.userId);
            return;
          }

          // ✅ User data found — populate normally
          this.hrVerification = {
            status: userData?.verificationStatus || 'Pending',
            comment: userData?.hrComment || '',
            readyForLetter: userData?.sendRelievingLetter || '',
            userId: userData?.userId || this.data?.userId,
            companyId: userData?.companyId || this.companyId,
            year: userData?.year || this.year,
            id:userData?.id
          };
        },
        error: (err) => {
          // ⛔ API call failed — set default fallback
          console.error('❌ Error fetching HR verification data:', err);
          this.hrVerification = {
            status: 'Pending',
            comment: '',
            readyForLetter: '',
            userId: this.data?.userId,
            companyId: this.companyId,
            year: this.year
          };
        }
      });
  }

  onReadyForLetterChange(item: any) {
    console.log(item);
    let message;
    if (item.readyForLetter == "Yes") {
      message = 'Are you sure you want to send letter?'
    } else {
      message = `Are you sure you don't want to send the letter?`
    }
    if (this.data == null) {
      return
    }
    const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
      disableClose: true,
      height: '25%',
      // width: '30%',
      width: window.innerWidth <= 576 ? '100%' : window.innerWidth <= 800 ? '50%' : '30%',

      data: {
        msg: message,
        btn2: 'Yes',
        btn1: 'No',
        btn2BgColor: this.buttonColorName,
        showSuccessIcon: false,
        showSuccessMessage: false,
        showCloseIcon: false,
      },
    });

    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) {
        // ✅ Only save if user confirmed
        this.saveHrVerification(item);

      } else {
        // ❌ Revert selection if cancelled
        this.hrVerificationMethod()
      }
    });
  }
  saveHrVerification(item: any) {
    console.log(item);

    let payload = {
      "id":item?.id,
      "companyId": item.companyId,
      "year": item.year,
      "hrComment": item?.comment,
      "userId": item?.userId,
      "verificationStatus": item?.status,
      "sendRelievingLetter": item?.readyForLetter
    }

    this.httpService.callPostService(`${this.config.saveHRVarification}`, payload).subscribe({
      next: (res: any) => {
        console.log('✅ API Success:', res);
        this.toastr.success(res.message);
        this.hrVerificationMethod()
      },
      error: (err) => {
        console.error('❌ API Error:', err);

        this.toastr.success('Failed to update  status.');
        this.hrVerificationMethod()
      }
    });

  }

  getHrVrification() {

  }

  downloadPDF() {
    const DATA: HTMLElement = document.getElementById('noDuesForm') as HTMLElement;

    // Temporarily expand the container so html2canvas can see all of it
    const originalHeight = DATA.style.height;
    DATA.style.height = 'auto';

    html2canvas(DATA, {
      scrollY: -window.scrollY,  // capture even off-screen
      scale: 2,
      useCORS: true
    }).then(canvas => {
      const imgWidth = 210; // A4 width
      const pageHeight = 297;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;

      let heightLeft = imgHeight;
      const pdf = new jsPDF('p', 'mm', 'a4');
      let position = 0;

      pdf.addImage(canvas.toDataURL('image/png'), 'PNG', 0, position, imgWidth, imgHeight);
      heightLeft -= pageHeight;

      while (heightLeft > 0) {
        position = heightLeft - imgHeight;
        pdf.addPage();
        pdf.addImage(canvas.toDataURL('image/png'), 'PNG', 0, position, imgWidth, imgHeight);
        heightLeft -= pageHeight;
      }

      pdf.save('No_Dues_Form.pdf');

      // restore height after export
      DATA.style.height = originalHeight;
    });
  }



}

